<template>
  <b-card>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header
            header-bg-variant="success"
            header-text-variant="light"
          >
            <h3>دارایی</h3>
          </b-card-header>
          <b-card-body>
            <div v-for="item in getdaraee" v-bind:key="item.id">
              <BalanceItem v-bind:item="item" v-bind:list="datas"></BalanceItem>
            </div>
          </b-card-body>
          <b-card-footer
            footer-bg-variant="success"
            footer-text-variant="light"
          >
            <b-row>
              <b-col>مجموع:</b-col>
              <b-col>{{ daraee.toLocaleString() }}</b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col>
        <b-card no-body>
          <b-card-header
            header-bg-variant="warning"
            header-text-variant="light"
          >
            <h3>بدهی</h3>
          </b-card-header>
          <b-card-body>
            <div v-for="item in getbedehi" v-bind:key="item.id">
              <BalanceItem v-bind:item="item" v-bind:list="datas"></BalanceItem>
            </div>
          </b-card-body>
          <b-card-footer
            footer-bg-variant="warning"
            footer-text-variant="light"
          >
            <b-row>
              <b-col>مجموع:</b-col>
              <b-col>{{
                (bedehi > 0 ? bedehi : -1 * bedehi).toLocaleString()
              }}</b-col>
            </b-row>
          </b-card-footer>
        </b-card>
        <b-card no-body>
          <b-card-header
            header-bg-variant="primary"
            header-text-variant="light"
          >
            <h3>حقوق صاحب سهام</h3>
          </b-card-header>
          <b-card-body>
            <div v-for="item in getsaham" v-bind:key="item.id">
              <BalanceItem v-bind:item="item" v-bind:list="datas"></BalanceItem>
            </div>
          </b-card-body>
          <b-card-footer
            footer-bg-variant="primary"
            footer-text-variant="light"
          >
            <b-row>
              <b-col>مجموع:</b-col>
              <b-col>{{
                (
                  sumMande + (sarmaye > 0 ? sarmaye : -1 * sarmaye)
                ).toLocaleString()
              }}</b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-7">
      <b-col>
        <h5 class="text-center">دارایی</h5>
      </b-col>
      <b-col>
        <h5 class="text-center">سرمایه + هزینه</h5>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <h5 class="text-center">{{ daraee.toLocaleString() }}</h5>
      </b-col>
      <b-col>
        <h5 class="text-center">
          {{
            (
              sumMande +
              (sarmaye > 0 ? sarmaye : -1 * sarmaye) +
              (bedehi > 0 ? bedehi : -1 * bedehi)
            ).toLocaleString()
          }}
        </h5>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../../helpers/httpHelper";
import BalanceItem from "./BalanceItem";
export default {
  name: "Balance",
  data() {
    return {
      datas: [],
      daraee: 0,
      bedehi: 0,
      sarmaye: 0,
      soodzianIndex: 0,
      sumMande: 0,
    };
  },
  created() {
    httpHelper.getData("balance").then((res) => {
      this.datas = res.result;
      this.datas.forEach((element, index) => {
        if (element.id == 32) {
          this.soodzianIndex = index;
        }
        if (element.mdGroup == 725) {
          this.daraee += element.sumBed - element.sumBes;
        } else if (element.mdGroup == 719) {
          this.bedehi += element.sumBed - element.sumBes;
        } else if (element.mdGroup == 723) {
          this.sarmaye += element.sumBed - element.sumBes;
        }
      });
      this.datas[this.soodzianIndex].sumBes = this.sumMande =
        this.daraee + this.bedehi + this.sarmaye;
    });
  },
  components: {
    BalanceItem,
  },
  computed: {
    getdaraee() {
      return this.datas.filter((element) => {
        return element.mdGroup == 725;
      });
    },
    getbedehi() {
      return this.datas.filter((element) => {
        return element.mdGroup == 719;
      });
    },
    getsaham() {
      return this.datas.filter((element) => {
        return element.mdGroup == 723;
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "ترازنامه" }]);
  },
};
</script>